import React, { createContext, useContext, useState, useEffect } from 'react';
import enTranslations from '../locales/en.json';
import ruTranslations from '../locales/ru.json';
import deTranslations from '../locales/de.json';
import esTranslations from '../locales/es.json';
import frTranslations from '../locales/fr.json';
import zhTranslations from '../locales/zh.json';
import plTranslations from '../locales/pl.json';
import srTranslations from '../locales/sr.json';
import ukTranslations from '../locales/uk.json';

const LanguageContext = createContext();

const translations = {
  en: enTranslations,
  ru: ruTranslations,
  de: deTranslations,
  es: esTranslations,
  fr: frTranslations,
  zh: zhTranslations,
  pl: plTranslations,
  sr: srTranslations,
  uk: ukTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Load saved language from localStorage or default to 'en'
    const savedLanguage = localStorage.getItem('portfolio_language') || 'en';
    setLanguage(savedLanguage);
  }, []);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('portfolio_language', newLanguage);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  const value = {
    language,
    changeLanguage,
    t,
    availableLanguages: [
      { code: 'en', name: 'English', countryCode: 'us' },
      { code: 'de', name: 'Deutsch', countryCode: 'de' },
      { code: 'fr', name: 'Français', countryCode: 'fr' },
      { code: 'es', name: 'Español', countryCode: 'es' },
      { code: 'uk', name: 'Українська', countryCode: 'ua' },
      { code: 'ru', name: 'Русский', countryCode: 'ru' },
      { code: 'pl', name: 'Polski', countryCode: 'pl' },
      { code: 'sr', name: 'Српски', countryCode: 'rs' },
      { code: 'zh', name: '中文', countryCode: 'cn' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
